var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGrid1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 120,
    height: 80,
    viewBox: "0 0 120 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Grid_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 80
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grid_1",
    "data-name": "Grid 1",
    clipPath: "url(#clip-Grid_1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2149",
    "data-name": "Group 2149"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2075",
    "data-name": "Group 2075",
    transform: "translate(-1092 583)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "_1",
    "data-name": 1,
    transform: "translate(1150 -515)",
    fontSize: 12,
    fontFamily: "Poppins-Medium, Poppins",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "1")), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_938",
    "data-name": "Rectangle 938",
    d: "M6,1A5.006,5.006,0,0,0,1,6V74a5.006,5.006,0,0,0,5,5H114a5.006,5.006,0,0,0,5-5V6a5.006,5.006,0,0,0-5-5H6M6,0H114a6,6,0,0,1,6,6V74a6,6,0,0,1-6,6H6a6,6,0,0,1-6-6V6A6,6,0,0,1,6,0Z",
    transform: "translate(1092 -583)",
    fill: "#707070"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2085",
    "data-name": "Group 2085",
    transform: "translate(-1247.515 -121)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2084",
    "data-name": "Group 2084",
    transform: "translate(-5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2063",
    "data-name": "Group 2063",
    transform: "translate(1279.515 144)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_786",
    "data-name": "Rectangle 786",
    d: "M2,1.5a.5.5,0,0,0-.5.5V14a.5.5,0,0,0,.5.5H64a.5.5,0,0,0,.5-.5V2a.5.5,0,0,0-.5-.5H2M2,0H64a2,2,0,0,1,2,2V14a2,2,0,0,1-2,2H2a2,2,0,0,1-2-2V2A2,2,0,0,1,2,0Z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid1);
export default __webpack_public_path__ + "static/media/Grid1.5593b41f5c2e9c1c186270c6e11a4df5.svg";
export { ForwardRef as ReactComponent };